export const MESSAGE_CONTACT_INFO_BLOCK_MESSAGE =
  "Please keep communication on MyTeenGig and remove phone numbers or email addresses from your message.";

export const MESSAGE_CONTACT_INFO_NOTICE =
  "For safety: no phone numbers, emails, or social handles before the gig is accepted.";

export const GIG_DESCRIPTION_CONTACT_INFO_BLOCK_MESSAGE =
  "Please remove phone numbers or email addresses from your gig description. Keep communication on MyTeenGig until a teen is accepted.";

export const GIG_DESCRIPTION_CONTACT_INFO_NOTICE =
  "For safety, do not include phone numbers, email addresses, social handles, or other personal contact information in the gig description.";

const emailPattern = /\b[a-z0-9._%+-]+\s*(?:@|\(at\)|\[at\])\s*[a-z0-9.-]+\s*(?:\.|\(dot\)|\[dot\])\s*[a-z]{2,}\b/i;
const phoneCandidatePattern = /(?:(?:\+?\d[\d().\s-]{8,}\d)|(?:\(\d{3}\)\s*\d{3}[-.\s]?\d{4}))/g;

export const containsBlockedContactInfo = (message: string): boolean => {
  if (emailPattern.test(message)) {
    return true;
  }

  const phoneMatches = message.match(phoneCandidatePattern) ?? [];
  return phoneMatches.some((candidate) => {
    const digits = candidate.replace(/\D/g, "");
    return digits.length >= 10 && digits.length <= 15;
  });
};
